"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductCatalogHandsetList = exports.getProductCatalogBrandNameList = exports.filterProductCatalogUnavailableHandesets = exports.filterProductCatalogEmptyBrands = void 0;
var _lodash = _interopRequireDefault(require("lodash.uniqby"));
var _lodash2 = _interopRequireDefault(require("lodash.uniq"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var getProductCatalogHandsetList = function getProductCatalogHandsetList(productOffering) {
  return (0, _lodash.default)(productOffering.map(function (handset, index) {
    return {
      id: index,
      model: handset.productSpecification.productSpecCharacteristic.find(function (characteristic) {
        return characteristic.name === 'model';
      }).productSpecCharacteristicValue[0].value,
      brand: handset.productSpecification.productSpecCharacteristic.find(function (characteristic) {
        return characteristic.name === 'brand';
      }).productSpecCharacteristicValue[0].value
    };
  }), function (handset) {
    return handset.model;
  });
};
exports.getProductCatalogHandsetList = getProductCatalogHandsetList;
var getProductCatalogBrandNameList = function getProductCatalogBrandNameList(productOffering) {
  return (0, _lodash2.default)(productOffering.map(function (handset) {
    var _handset$productSpeci;
    return (_handset$productSpeci = handset.productSpecification.productSpecCharacteristic.find(function (characteristic) {
      return characteristic.name === 'brand';
    }).productSpecCharacteristicValue[0].value) === null || _handset$productSpeci === void 0 ? void 0 : _handset$productSpeci.toLowerCase();
  }));
};
exports.getProductCatalogBrandNameList = getProductCatalogBrandNameList;
var filterProductCatalogEmptyBrands = function filterProductCatalogEmptyBrands(productOffering) {
  return productOffering.filter(function (handset) {
    return handset.productSpecification.productSpecCharacteristic.find(function (characteristic) {
      return characteristic.name === 'brand';
    }).productSpecCharacteristicValue[0].value !== undefined;
  });
};
exports.filterProductCatalogEmptyBrands = filterProductCatalogEmptyBrands;
var filterProductCatalogUnavailableHandesets = function filterProductCatalogUnavailableHandesets(productOffering) {
  return productOffering.filter(function (handset) {
    return handset.prodSpecCharValueUse.find(function (characteristic) {
      return characteristic.name === 'stockAvailability';
    }).productSpecCharacteristicValue[0].value === true;
  });
};
exports.filterProductCatalogUnavailableHandesets = filterProductCatalogUnavailableHandesets;